import { render, staticRenderFns } from "./GeneralTableMaterial.vue?vue&type=template&id=2bbc50da&scoped=true&"
import script from "./GeneralTableMaterial.vue?vue&type=script&lang=js&"
export * from "./GeneralTableMaterial.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTableMaterial.vue?vue&type=style&index=0&id=2bbc50da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc50da",
  null
  
)

export default component.exports